import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { getEventHistoryThunk } from "../../../store/events/eventThunk";
import { EVENT_TYPE_HISTORY } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";

const Completed = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);

  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventHistoryThunk({
        type: EVENT_TYPE_HISTORY.COMPLETED,
        isLoading: false,
      })
    );
  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      await dispatch(
        getEventHistoryThunk({
          type: EVENT_TYPE_HISTORY.COMPLETED,
          isLoading: true,
        })
      );
      setShouldStartUpdating(true);
    };
    getData();
  }, []);

  return (
    <EventGrid
      gridId={`EVENT_COMPLETED`}
      eventType={"COMPLETED"}
      showSave={false}
      title={"Completed Events"}
      queryParams={ROUTE_QUERY_CONSTANTS.Completed}
    />
  );
};

export default Completed;
